<template>
  <div class="CardinfoDv">
    <PortfolioTradeCard :trade="trade[0]" :stockName="stock.name" :postUser="postUser" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from "vue";
import PortfolioTradeCard from "../add-post/AddPortfolioTrade/PortfolioTradeComponent/PortfolioTradeCard.vue";
// import PortfolioTradeCard from "../add-post/AddPortfolioTrade/PortfolioTradeComponent/NewPortfolioTradeCard.vue";
import { useSocketStockData } from "@/composables/stock_data.composable";
export default defineComponent({
  props: ["trade", "stock", "postUser"],

  components: {
    PortfolioTradeCard,
  },

  setup(props, context) {

    const preSetData = computed(() => {
      if (props.stock) {
        return {
          symbol: props.trade[0]?.symbol || '',
          stockId: props.stock.stockId || '',
          companyName: props.stock.name,
          stockType: props.stock.market,
          totalOrders: props.trade.length,
          orders: props.trade.map((item) => ({
            type: item.side,
            shares: item.Qty,
            price: item.limit_price,
            totalPrice: item.Qty * item.limit_price,
            orderDate: item.created_at
          })),
          position: "long",
          tradeType: "Swing Trade",
          tradeStatus: "open",
          pprice: 0,
          shares: 0,
          totalPrice: 0,
          gainPercent: 0
        };
      }
      return {}; // Return an empty object if props.stock is not available
    });

    const initialObject = () => {
      return {
        _id: props.trade?.stockId,
        type: props.trade?.stockType,
        symbol: props.trade?.symbol,
        stockId: props.trade?.stockId,
      };
    };

    const { stockData: stock, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );
    function calcFunc(postTradingDTO) {
        if(postTradingDTO && postTradingDTO.orders && postTradingDTO.orders.length > 0){
      const sortedOrders = postTradingDTO.orders.sort((a, b) => new Date(a.orderDate).getTime() - new Date(b.orderDate).getTime());
      let position = sortedOrders[0].type === 'sell' ? "short" : "long";
      let tradeType = Array.from(new Set(postTradingDTO.orders.map(x => x.orderDate))).length === 1 ? "dayTrade" : "swing";
      let tradeStatus = "";
      let orderTypes = postTradingDTO.orders.map(x => x.type);
      let sellShareQuantity = postTradingDTO.orders.filter(x => x.type === "sell").map(x => x.shares).reduce((a, b) => a + b, 0);
      let buyShareQuantity = postTradingDTO.orders.filter(x => x.type === "buy").map(x => x.shares).reduce((a, b) => a + b, 0);
      let shares = sellShareQuantity == 0 ? buyShareQuantity : sellShareQuantity;
      let buyOrders = postTradingDTO.orders.filter(x => x["type"] == "buy");
      let sellOrders = postTradingDTO.orders.filter(x => x["type"] == "sell");
      let pprice = 0;
      let totalBuyPrice = buyOrders.map(x => x["price"]*x["shares"]).reduce((a, b) => a + b, 0);
      let totalSellPrice = sellOrders.map(x => x["price"]*x["shares"]).reduce((a, b) => a + b, 0);
      if (orderTypes.includes("buy") && orderTypes.includes("sell")) {
        if (sellShareQuantity == buyShareQuantity) {
          tradeStatus = "close";
        } else {
          tradeStatus = "partiallyClosed";
        }
      } else if (orderTypes.includes("buy")) {
        tradeStatus = "open";
      } else if (orderTypes.includes("sell")) {
        tradeStatus = "open";
      }
      if (buyShareQuantity > 0) {
        pprice = totalBuyPrice / buyShareQuantity;
      } else if (buyShareQuantity === 0 && sellShareQuantity > 0) {
        pprice = totalSellPrice / sellShareQuantity;
      }
      let finalGain = 0;
      let finalGainPercent = 0;
      let totalPrice = 0;
      if (totalSellPrice > 0) {
        totalPrice = totalSellPrice - totalPrice;
      } else {
        totalPrice = totalBuyPrice;
      }
      if (totalSellPrice > 0) {
        let avgBuyingPrice = buyOrders.length > 0 ? totalBuyPrice / buyOrders.length : 0;
        let avgSellingPrice = sellOrders.length > 0 ? totalSellPrice / sellOrders.length : 0;
        let totalSoldShares = sellOrders.map(x => x["shares"]).reduce((a, b) => a + b, 0);
        let costPrice = avgBuyingPrice * totalSoldShares;
        let sellingPriceTotal = avgSellingPrice * totalSoldShares;
        finalGain = sellingPriceTotal - costPrice;
        finalGainPercent = costPrice !== 0 ? (finalGain / costPrice) * 100 : 0;
      } 
      let tradeObj = {
        symbol: postTradingDTO.symbol ?? "",
        stockId: postTradingDTO.stockId ?? "",
        companyName: postTradingDTO.companyName ?? "",
        stockType: postTradingDTO.stockType ?? "",
        position: position ?? "",
        tradeType: tradeType ?? "",
        tradeStatus: tradeStatus ?? "",
        shares: isNaN(shares) ? 0 : shares,
        pprice: isNaN(pprice) ? 0 : pprice,
        gain: isNaN(finalGain) ? 0 : finalGain,
        totalPrice: isNaN(totalPrice) ? 0 : totalPrice,
        gainPercent: isNaN(finalGainPercent) || !isFinite(finalGainPercent) ? 0 : finalGainPercent,
        totalOrders: isNaN(postTradingDTO.orders?.length) ? 0 : postTradingDTO.orders.length,
        orders: postTradingDTO.orders ?? [],
      };
      return tradeObj;
    }
    return {}
    }

    const traderesult = computed(() => {
      if (preSetData.value) {
        return calcFunc(preSetData.value);
      }
      return {};
    });

    onMounted(() => { 
        // console.log(props.trade, 'trade orignal');
        
    });
    return {
        stock: props.stock,
        preSetData: preSetData.value,
        traderesult: traderesult.value,
        livestock: stock
    };
  },
});
</script>
<style lang="scss" scoped>
.CardinfoDv {
  background: var(--base-dark);
  padding: 20px;
  border-radius: 15px;
  justify-content: center;
  display: flex;
}

@media screen and (min-width: 1280px) and (max-width: 1891px) {
  .CardinfoDv {
    padding: 6px;
    border-radius: 15px;
  }

}

@media only screen and (min-width: 320px) and (max-width: 1279px) {
  .CardinfoDv {
      padding: 7px;
      .new-trade-card {
        width: 100%;
      }
  }
}
</style>